import type { AgentActionPayload } from "@carbon-operations/contracts";

// Rendered as React text nodes only (escaped); the requester controls every value.
export function AgentActionFacts({ action, requestedBy }: { action: AgentActionPayload; requestedBy?: string | undefined }) {
  const rows: [string, string][] = [
    ...(requestedBy === undefined ? [] : [["Requested by (operator)", requestedBy] as [string, string]]),
    ["Project", action.project],
    ["Action class", action.action_class],
    ["Risk", action.risk],
    ["Target", action.target],
    ["Summary", action.summary],
    ["Plan SHA-256", action.plan_sha256],
  ];
  return (
    <dl className="agent-action-facts" aria-label="Requested agent action">
      {rows.map(([term, value]) => (
        <div className="definition" key={term}>
          <dt>{term}</dt>
          <dd>{value}</dd>
        </div>
      ))}
    </dl>
  );
}
